
import { loadCustomScript } from '@paypal/paypal-js'
import helpers from '../components/helpers'
import constructUrl from '../tools/urlHelper'

const mbaUrl = '/api/mba'
const dropzoneCdn = 'https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/min/dropzone.min.js'

const materialOptions = [
    { value: 'STST', name: 'Stainless Steel' },
    { value: 'A2', name: 'Stainless Steel - A2 / 304' },
    { value: 'A4', name: 'Stainless Steel - A4 / 316' },
    { value: 'AL', name: 'Aluminium' },
    { value: 'BR', name: 'Brass' },
    { value: 'NY', name: 'Nylon' },
    { value: 'PK', name: 'Peek' },
    { value: 'PB', name: 'Phosphor Bronze' },
    { value: 'ST', name: 'Steel Mild' },
    { value: 'HS', name: 'Steel Hardened' },
    { value: 'TI', name: 'Titanium' },
]

const certificationOptions = [
    { value: 'Positive Material Identification (PMI)', name: 'Positive Material Identification (PMI)' },
    { value: '3.1 Material Certificate', name: '3.1 Material Certificate' },
    { value: 'REACh', name: 'REACh' },
    { value: 'RoHS', name: 'RoHS' },
//    { value: 'POPs', name: 'POPs' },
//    { value: 'PFAS', name: 'PFAS' },
//    { value: 'TSCA', name: 'TSCA' },
//    { value: 'Prop 65', name: 'Prop 65' },
    { value: 'Other', name: 'Other' },
]

const mbaForm = () => ({
    ...window.helpers,
    step: 1,
    name: (window.Alpine.store('user').isLoggedIn) ? `${window.Alpine.store('user').firstname} ${window.Alpine.store('user').lastname}` : '',
    email: (window.Alpine.store('user').isLoggedIn) ? window.Alpine.store('user').email : '',
    phone: (window.Alpine.store('user').isLoggedIn) ? (window.Alpine.store('user').phone || '') : '',
    job_title: (window.Alpine.store('user').isLoggedIn) ? (window.Alpine.store('user').job_title || '') : '',
    delivery_country: null,
    description: '',
    quantity: '',
    materials: [],
    certifications: [],
    certifications_other: null,
    materialOptions,
    certificationOptions,
    tolerances: '',
    file: '',
    industry: '',
    industry_other: '',
    required_delivery_date: '',
    mutual_nda: 0,
    safety_critical: 0,
    is_itar: 0,
    files: [],
    uploadProgress: false,
    folder: null,
    mba: null,
    dzAttached: false,
    submitting: false,
    fieldKeys: [
        'name',
        'email',
        'phone',
        'job_title',
        'delivery_country',
        'description',
        'quantity',
        'materials',
        'certifications',
        'certifications_other',
        'tolerances',
        'file',
        'industry',
        'industry_other',
        'required_delivery_date',
        'mutual_nda',
        'safety_critical',
        'is_itar',
    ],
    initMbaForm() {
        const defaultCountryId = this.$el.dataset.defaultCountryId || 17
        this.delivery_country = parseInt(defaultCountryId)

        const action = `${mbaUrl}?action=retrieve`
        const formData = new FormData()

        formData.append('email', this.email)

        this.$watch('industry', (value) => {
            if (value !== 'other') {
                this.industry_other = '';
            }
        });

        window.api.post(action, formData).then((response) => {
            const data = response.data.message.mba
            const { folder } = response.data.message
            const files = response.data.message.files || []

            this.folder = folder

            if (!data) {
                this.submitting = false
                return
            }

            this.files = files
            this.mba = data

            // Step 1
            this.name = data.contact_name
            this.phone = data.phone || ''
            this.job_title = data.job_title || ''
            // data.industry is the label stored with industry_id, or for other what they typed
            this.industry = data.industry_id || ''
            this.industry_other = data.industry_id === 'other' ? (data.industry || '') : ''
            this.delivery_country = data.id_country

            // Step 2
            this.description = data.notes || ''
            this.quantity = data.quantity || ''
            this.tolerances = data.tolerances || ''

            if (data.material) {
                data.material.split(', ').map((m) => this.materials.push(m)) || []
            }

            if (data.certifications) {
                data.certifications.split(', ').map((m) => this.certifications.push(m)) || []
            }

            // Step 3
            this.required_delivery_date = data.date_project ? new Date(data.date_project).toISOString().substr(0, 10) : ''
            this.mutual_nda = data.mutual_nda || 0
            this.safety_critical = data.safety_critical || 0

            this.submitting = false
        }).catch((error) => {
            const errorResponse = error.response || error

            window.dispatchEvent(new CustomEvent('create-toast', {
                detail: {
                    title: 'We encountered a problem...',
                    message: errorResponse.data ? errorResponse.data.message : errorResponse,
                    type: 'error',
                },
            }))

            this.submitting = false
        })
    },
    addMaterial(value) {
        this.materials[value.trim()]
    },
    addCertification(value) {
        this.certifications[value.trim()]
    },
    submitStep(currentStep) {
        const action = `${mbaUrl}?action=step${currentStep}`
        const formData = new FormData()

        this.submitting = true

        formData.append('email', this.email)

        if (currentStep === 1) {
            formData.append('name', this.name)
            formData.append('phone', this.phone)
            formData.append('job_title', this.job_title)
            formData.append('industry', this.industry)
            formData.append('industry_other', this.industry_other)
            formData.append('delivery_country', this.delivery_country)
        }

        if (currentStep === 2) {
            formData.append('description', this.description)
            formData.append('quantity', this.quantity)
            formData.append('tolerances', this.tolerances)
            this.materials.map((material) => formData.append('materials[]', material))
            this.certifications
                .filter(cert => cert !== 'Other')
                .forEach(cert =>
                    formData.append('certifications[]', cert)
                )
            formData.append('certifications_other', this.certifications_other)
        }

        if (currentStep === 3) {
            formData.append('required_delivery_date', this.required_delivery_date)
            formData.append('mutual_nda', (this.mutual_nda == true) ? 1 : 0)
            formData.append('safety_critical', (this.safety_critical == true) ? 1 : 0)
            formData.append('is_itar', (this.is_itar == true) ? 1 : 0)
        }

        if (window.Alpine.store('gclid').gclid !== null && window.Alpine.store('gclid').utl !== null && new Date().getTime() < window.Alpine.store('gclid').utl) {
            formData.append('offline_tracking_gclid', window.Alpine.store('gclid').gclid)
        }

        return window.api.post(action, formData)
    },
    submitStepAndGoTo(submitStep, goToStep, skipValidation = false) {
        this.errors = {}

        // For scenarios when we want to go back, we don't attempt to validate / submit the step.
        // If we didn't do this the user would be presented with errors which would prevent
        // them from going back, which would probably frustrate users.
        if (skipValidation) {
            if (goToStep === 2) {
                // Account for scenarios when we are going from step 3 to 2, still need to setup dropzone!
                this.$nextTick(() => this.setupDropzone(this.mba, this.folder))
            }

            this.submitting = false
            this.step = goToStep

            window.location.hash = ''

            this.$nextTick(() => {
                window.location.hash = '#custom-manufacture-form'
            })
            return
        }

        const promiseChain = []

        promiseChain.push(this.submitStep(submitStep))

        if (goToStep === 2) {
            promiseChain.push(loadCustomScript({ url: dropzoneCdn }))
        }

        Promise.all(promiseChain).then((result) => {
            const inProgress = result[0].data.message

            this.mba = inProgress.mba
            this.folder = inProgress.folder

            this.submitting = false
            this.step = goToStep

            window.location.hash = ''

            this.$nextTick(() => {
                window.location.hash = '#custom-manufacture-form'
            })

            if (goToStep === 2) {
                this.$nextTick(() => {
                    this.setupDropzone(this.mba, this.folder)

                    if (this.dzAttached) {
                        return
                    }

                    document.addEventListener('updateFiles', (evt) => this.files = evt.detail.files)
                    document.addEventListener('uploadError', (evt) => {
                        if (typeof evt.detail.error.errors.file[0] === 'string' || evt.detail.error.errors.file[0] instanceof String) {
                            this.processServersideErrors({
                                errors: {
                                    file: [evt.detail.error.errors.file[0]],
                                },
                            })
                        } else {
                            this.processServersideErrors(evt.detail.error.errors.file[0])
                        }
                    })
                    document.addEventListener('uploadProgress', (evt) => this.uploadProgress = evt.detail.progress)
                    document.addEventListener('toggleSubmitting', (evt) => this.submitting = evt.detail.submitting)

                    this.dzAttached = true
                })
            }

            if (goToStep === 4) {
                window.dispatchEvent(new CustomEvent('gtmdata', {
                    detail: {
                        event: 'gtm_mba',
                    },
                }))
            }
        }).catch((error) => {
            const errorResponse = error.response || error

            window.dispatchEvent(new CustomEvent('create-toast', {
                detail: {
                    title: 'We encountered a problem...',
                    message: errorResponse.data ? errorResponse.data.message : errorResponse,
                    type: 'error',
                },
            }))

            this.processServersideErrors(errorResponse.data || error)
            this.submitting = false
        })
    },
    setupDropzone(mba, folder) {
        const action = `${mbaUrl}?action=upload`

        Dropzone.autoDiscover = false

        const url = constructUrl(action)

        new Dropzone('div#dropzone', {
            init() {
                this.on('sending', (file, xhr, formData) => {
                    document.dispatchEvent(new CustomEvent('toggleSubmitting', {
                        detail: {
                            submitting: true,
                        },
                    }))

                    formData.append('folder', folder)
                    formData.append('id_mba', mba.id_mba)
                }),
                this.on('totaluploadprogress', (progress) => {
                    progress = parseInt(progress)

                    if (progress === 100) {
                        progress = false
                    }

                    document.dispatchEvent(new CustomEvent('uploadProgress', {
                        detail: {
                            progress,
                        },
                    }))
                }),
                this.on('success', (file, response) => {
                    const { files } = response.message

                    document.dispatchEvent(new CustomEvent('updateFiles', {
                        detail: {
                            files,
                        },
                    }))

                    document.dispatchEvent(new CustomEvent('toggleSubmitting', {
                        detail: {
                            submitting: false,
                        },
                    }))
                }),
                this.on('error', (file, response) => {
                    let errorResponse

                    try {
                        errorResponse = JSON.parse(response)
                    } catch (error) {
                        errorResponse = {
                            errors: {
                                file: [
                                    response,
                                ],
                            },
                        }
                    }

                    this.removeFile(file)

                    document.dispatchEvent(new CustomEvent('uploadError', {
                        detail: {
                            error: errorResponse,
                            file,
                        },
                    }))

                    document.dispatchEvent(new CustomEvent('toggleSubmitting', {
                        detail: {
                            submitting: false,
                        },
                    }))

                    document.dispatchEvent(new CustomEvent('uploadProgress', {
                        detail: {
                            progress: false,
                        },
                    }))
                })
            },
            paramName: 'file',
            acceptedFiles: '.jpg, .jpeg, .png, .pdf, .dwg, .step, .st, .stp, .iges, .stl, .dxf, .dgn, .sldprt, .sldasm, .x_t, .iam, .ipt, .skp',
            maxFilesize: 20,
            url: url,
            createImageThumbnails: false,
            previewTemplate: '<div style="display:none"></div>',
        })
    },
    removeFile(file) {
        const action = `${mbaUrl}?action=remove`
        const formData = new FormData()
        const index = this.files.findIndex((f) => f.id_mba_attachment === file.id_mba_attachment)

        this.submitting = true

        formData.append('file_name', file.file_name)

        window.api.post(action, formData).then((response) => {
            this.submitting = false
            this.files.splice(index, 1)
        }).catch((error) => {
            const errorResponse = error.response || error

            window.dispatchEvent(new CustomEvent('create-toast', {
                detail: {
                    title: 'We encountered a problem...',
                    message: errorResponse.data ? errorResponse.data.message : errorResponse,
                    type: 'error',
                },
            }))

            this.submitting = false
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('mbaForm', mbaForm)
})
